import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { ApiResponse, BaseApiService } from 'src/app/api/base';

@Injectable({
  providedIn: 'root'
})
export class MonthlyCalendarService extends BaseApiService<any> {
  //https://dev.jarvis.bpc.com/api/travelevents
  constructor(authService: AuthService,
    router: Router,
    messageService: MessageService,) { 
    super("/", authService, router, messageService);
  }

  fetchMonthlyCalendarData(): Observable<ApiResponse<any>> {
    return this.get(`/travelevents`);
  }
}
